export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '韩漫之家是免费的吗？',
    answer: '是的，韩漫之家完全免费！我们致力于为广大韩漫爱好者提供优质的免费阅读体验。所有漫画均可在网站上免费在线观看，无需付费订阅。',
  },
  {
    question: '什么是下拉式韩漫？',
    answer: '下拉式韩漫是韩国漫画独特的阅读方式，漫画内容纵向排列，读者只需向下滑动即可连续阅读。这种形式非常适合手机端阅读，让您随时随地畅享韩漫。',
  },
  {
    question: '网站支持哪些设备访问？',
    answer: '韩漫之家支持所有主流设备访问，包括电脑、平板和手机。我们的网站采用响应式设计，会根据您的设备屏幕自动调整显示效果，确保最佳的阅读体验。',
  },
  {
    question: '漫画更新的频率是怎样的？',
    answer: '连载中的作品通常每周更新一到两话，具体更新频率取决于作者和版权方安排。我们会在第一时间同步更新，您可以关注喜欢的作品获取最新通知。',
  },
  {
    question: '如何找到我喜欢的漫画类型？',
    answer: '您可以通过首页的分类导航浏览不同类型的漫画，也可以在搜索框中直接输入作品名称或作者进行搜索。我们提供了浪漫爱情、热血动作、奇幻冒险等多种分类供您选择。',
  },
  {
    question: '网站上可以下载漫画吗？',
    answer: '目前韩漫之家仅支持在线阅读，暂不提供下载功能。我们建议您将喜欢作品的页面加入书签，方便下次快速访问继续阅读。',
  },
];